import LinkStatus from 'modules/integrations_silae_api/components/IntegrationLinkStatus'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PayrollPaywallGuard from 'modules/payroll_bundle/pages/PayrollPaywallGuard'

const Settings = () => {
  return (
    <PayrollPaywallGuard>
      <ResponsivePage.Body>
        <LinkStatus />
      </ResponsivePage.Body>
    </PayrollPaywallGuard>
  )
}

export default Settings
